import { render, staticRenderFns } from "./bottom-navigation-component.vue?vue&type=template&id=1ef90596&scoped=true&"
import script from "./bottom-navigation-component.vue?vue&type=script&lang=ts&"
export * from "./bottom-navigation-component.vue?vue&type=script&lang=ts&"
import style0 from "./bottom-navigation-component.vue?vue&type=style&index=0&id=1ef90596&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef90596",
  null
  
)

export default component.exports